
import React, { useState } from "react";
import { SidebarFooter } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/AuthContext";
import ImportDataDialog from "@/components/common/ImportDataDialog";
import ImportBookmarksDialog from "@/components/common/ImportBookmarksDialog";
import ExportBookmarksDialog from "@/components/common/ExportBookmarksDialog";
import FeedbackButton from "@/components/common/FeedbackButton";
import UserAvatarMenu from "./sidebar/UserAvatarMenu";
import PasswordResetDialog from "./sidebar/PasswordResetDialog";
import DeleteAccountDialog from "./sidebar/DeleteAccountDialog";
import ExtensionMenu from "./sidebar/ExtensionMenu";
import SettingsMenu from "./sidebar/SettingsMenu";
import AdminButton from "./sidebar/AdminButton";
import ThemeToggle from "./sidebar/ThemeToggle";

const SidebarFooterSection = () => {
  const { user } = useAuth();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const [isImportBookmarksOpen, setIsImportBookmarksOpen] = useState(false);
  const [isExportBookmarksOpen, setIsExportBookmarksOpen] = useState(false);
  
  const isAdmin = user?.email === "grayholland@ux-flo.com";

  return (
    <SidebarFooter className="py-0 px-0 border-t border-border dark:border-border h-[80px]">
      <div className="flex items-center justify-between h-full px-3">
        <UserAvatarMenu 
          onResetPassword={() => setIsResetPasswordOpen(true)}
          onDeleteAccount={() => setIsDeleteDialogOpen(true)}
        />
        
        <FeedbackButton />
        
        <ExtensionMenu />
        
        <ThemeToggle />
        
        <AdminButton isAdmin={isAdmin} />
        
        <SettingsMenu 
          onImportData={() => setIsImportDialogOpen(true)}
          onImportBookmarks={() => setIsImportBookmarksOpen(true)}
          onExportBookmarks={() => setIsExportBookmarksOpen(true)}
        />
      </div>
      
      <DeleteAccountDialog 
        open={isDeleteDialogOpen} 
        onOpenChange={setIsDeleteDialogOpen} 
      />

      <PasswordResetDialog 
        open={isResetPasswordOpen} 
        onOpenChange={setIsResetPasswordOpen} 
      />

      <ImportDataDialog 
        open={isImportDialogOpen} 
        onOpenChange={setIsImportDialogOpen} 
      />
      
      <ImportBookmarksDialog
        open={isImportBookmarksOpen}
        onOpenChange={setIsImportBookmarksOpen}
      />

      <ExportBookmarksDialog
        open={isExportBookmarksOpen}
        onOpenChange={setIsExportBookmarksOpen}
      />
    </SidebarFooter>
  );
};

export default SidebarFooterSection;
